module.exports = __webpack_public_path__ + "img/strip_head_a.4c811f5b.jpg";